"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonWrapper = _interopRequireDefault(require("UIComponents/layout/UIButtonWrapper"));

var RichTextEditorError =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(RichTextEditorError, _Component);

  function RichTextEditorError() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RichTextEditorError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RichTextEditorError)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleAttemptToRemount = function () {
      _this.props.resetRetryCount();

      _this.props.attemptToRemount();
    };

    return _this;
  }

  (0, _createClass2.default)(RichTextEditorError, [{
    key: "render",
    value: function render() {
      var enableManualRetry = this.props.enableManualRetry;
      return _react.default.createElement(_UIAlert.default, {
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: "customerDataCommunicator.richTextEditor.header"
        }),
        className: "m-x-5 m-top-3 p-top-4",
        type: "danger"
      }, _react.default.createElement(_UIButtonWrapper.default, null, _react.default.createElement("div", {
        className: "m-left-3 m-y-1"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "customerDataCommunicator.richTextEditor.errorRetry"
      })), enableManualRetry && _react.default.createElement(_UIButton.default, {
        onClick: this.handleAttemptToRemount,
        use: "tertiary",
        size: "xs",
        className: "m-bottom-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "customerDataCommunicator.richTextEditor.retryButton"
      }))));
    }
  }]);
  return RichTextEditorError;
}(_react.Component);

exports.default = RichTextEditorError;
RichTextEditorError.propTypes = {
  attemptToRemount: _react.PropTypes.func.isRequired,
  resetRetryCount: _react.PropTypes.func.isRequired,
  enableManualRetry: _react.PropTypes.bool.isRequired
};
module.exports = exports.default;